import api from './axios';

export async function get_all_providers() {
    try {
        let res = await api.get('/providers/');
        res = res.data;
        return res;
    } catch (err) {
        throw err;
    }
}

// export async function get_beneficiary_by_id(beneficiary_id) {
//     try {
//         let res = await api.get(`/beneficiaries/${beneficiary_id}`);
//         res = res.data;
//         return res;
//     }
//     catch (err) {
//         console.log(err);
//         throw err;
//     }
// }

export async function add_provider(provider) {
    try {
        let res = await api.post('/providers/add', provider);
        res = res.data;
        return res;
    }
    catch (err) {
        if (err.response) {
            throw {
                message: err.response.data.error,
                status: err.response.status
            };
        }
        throw { message: "Unknown error", status: 500 };
    }
}

// export async function update_beneficiary(beneficiary) {
//     try {
//         const res = await api.put(`/beneficiaries/update/${beneficiary.id}`, beneficiary);
//         return res.data;
//     } catch (err) {
//         console.log("Error updating beneficiary:", err);
//         throw err;
//     }
// }


// export async function delete_beneficiary(beneficiary_id) {
//     try {
//         const res = await api.delete(`/beneficiaries/delete/${beneficiary_id}`);
//         return res.data;
//     } catch (err) {
//         console.log(err);
//         throw err;
//     }
// }

